module.exports = __webpack_public_path__ + "media/components/assets/images/cooingklePackage/image9-d7070e52513ea80ac44f8955ebdcb319.png";